import axios from '@axios'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useBulkChangeTransactionsStatusModal() {
  // Use toast
  const toast = useToast()

  const updateTransactionsStatus = queryParams => axios
    .post('auth/transactions/bulk-actions/update-status', queryParams)
    .then(response => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Status was successfully updated',
          icon: 'ThumbsUpIcon',
          variant: 'info',
        },
      })
      return response.data.data
    })
    .catch(error => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Error updating Status',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
      return error
    })
  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  return {
    updateTransactionsStatus,
  }
}
